export default __webpack_public_path__ + "static/amazon-6c6a86807e8b169483b33cf23f0edc4a.svg";